import { render } from "./AddRulePage.vue?vue&type=template&id=26efbf8c&ts=true"
import script from "./AddRulePage.vue?vue&type=script&lang=ts"
export * from "./AddRulePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__